module.exports = __webpack_public_path__ + "static/img/7.7fd2dfd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/sp/7.png
// module id = O8p6
// module chunks = 0